import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const BulkActionsDropdown = ({
  selectedCount,
  onReassign,
  onDelete,
  onClearSelection,
  uniqueId = 'default',
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const handleKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('click', handleDocClick);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('click', handleDocClick);
      document.removeEventListener('keydown', handleKey);
    };
  }, []);

  const handleClick = (callback) => {
    setOpen(false);
    callback?.();
  };

  return (
    <div className="dropdown" ref={ref}>
      <button
        type="button"
        id={`bulk-actions-dropdown-button-${uniqueId}`}
        className="btn btn-primary dropdown-toggle"
        aria-label="Bulk actions"
        aria-expanded={open}
        aria-haspopup="true"
        onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}
      >
        Bulk Actions ({selectedCount})
      </button>
      <div
        className={`dropdown-menu dropdown-menu-end${open ? ' show' : ''}`}
        role="menu"
        aria-labelledby={`bulk-actions-dropdown-button-${uniqueId}`}
        style={{ right: 0, left: 'auto', zIndex: 1050 }}
      >
        <button className="dropdown-item" onClick={() => handleClick(onReassign)}>
          Reassign
        </button>
        {onDelete && (
          <button className="dropdown-item text-danger" onClick={() => handleClick(onDelete)}>
            Delete
          </button>
        )}
        <div className="dropdown-divider" />
        <button className="dropdown-item text-muted" onClick={() => handleClick(onClearSelection)}>
          Clear selection
        </button>
      </div>
    </div>
  );
};

BulkActionsDropdown.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  onReassign: PropTypes.func,
  onDelete: PropTypes.func,
  onClearSelection: PropTypes.func,
  uniqueId: PropTypes.string,
};

export default BulkActionsDropdown;
